import { call, delay, put, race, takeLatest, take, cancelled } from 'redux-saga/effects';
import {
  PAYMENTS_CLAIMS_PAID_REQUEST,
  CLAIMS_YIELD_ALL_PASSES_METRICS_REQUEST,
  SERVICE_TYPE_PASS_WISE_METRICS_REQUEST,
  PAYMENTS_CLAIMS_SUMMARY_REQUEST,
  PAYMENTS_CLAIMS_DOP_REQUEST,
  CLAIMS_BIFURCATE_METRICS_REQUEST,
  PAYMENTS_CLAIMS_DOP_CANCEL,
  PAYMENTS_CLAIMSBIFURCATE_CANCEL,
  PAYMENTS_CLAIMSPAID_CANCEL,
  PAYMENTS_CLAIMSSUMMARY_CANCEL,
  PAYMENTS_CLAIMSYIELD_CANCEL,
  PAYMENTS_CLAIMS_SERVICE_PASS_CANCEL
} from '../../../actions/actionTypes';
import {
  fetchPaymentsClaimsPaidError,
  fetchPaymentsClaimsPaidLoading,
  fetchPaymentsClaimsPaidSuccess,
  fetchClaimsYieldAllPassesMetricsError,
  fetchClaimsYieldAllPassesMetricsLoading,
  fetchClaimsYieldAllPassesMetricsSuccess,
  fetchServiceTypePassWiseMetricsError,
  fetchServiceTypePassWiseMetricsLoading,
  fetchServiceTypePassWiseMetricsSuccess,
  fetchPaymentsClaimsSummaryError,
  fetchPaymentsClaimsSummaryLoading,
  fetchPaymentsClaimsSummarySuccess,
  fetchPaymentsClaimsDopError,
  fetchPaymentsClaimsDopLoading,
  fetchPaymentsClaimsDopSuccess,
  fetchClaimsBifurcateMericsError,
  fetchClaimsBifurcateMericsLoading,
  fetchClaimsBifurcateMericsSuccess,
  paymentsPollingCompleted,
  paymentsPollingStarted,
  paymentsPollingFailed
} from '@src/middleware/actions/Reimbursement/paymentActions';
import {
  getPaymentsClaimPaidDataRequest,
  getClaimsYieldAllPassesMetricsDataRequest,
  getServiceTypePassWiseMetricsDataRequest,
  getPaymentsClaimsSummaryDataRequest,
  getDOPClaimsSummaryDataRequest,
  getClaimsBifurcateMetricsDataRequest,
  getDOPClaimsSummaryDataRequestBulk,
  getClaimsBifurcateMetricsDataRequestBulk,
  getPaymentsClaimPaidDataRequestBulk,
  getPaymentsClaimsSummaryDataRequestBulk,
  getClaimsYieldAllPassesMetricsDataRequestBulk,
  getServiceTypePassWiseMetricsDataRequestBulk
} from '@src/middleware/services/reimbusement/payments/payments.service';
import { reimbursementPollingStarted, reimbursementPollingCompleted } from '@src/middleware/actions/Reimbursement/reiumbursementTabDataAction';


export function* getDOPClaimsSummaryData(action: any) {
  const payload = action?.payload;
  const key = sessionStorage.getItem('HIVOLUMETINFLOW') === 'true'
    || sessionStorage.getItem('hiVolumeContractFlow') === 'true';
  const correlationId = `getDOPClaimsSummaryData-${Date.now()}`;
  let stopPollingFn: (() => void) | undefined;
  try {
      if (key) {
yield put(paymentsPollingStarted());
        yield put(reimbursementPollingStarted(correlationId));
      }
      yield put(fetchPaymentsClaimsDopLoading(true));
      const { result, cancel } = yield race({
        result:yield  call(
          !key ? getDOPClaimsSummaryDataRequest : getDOPClaimsSummaryDataRequestBulk,
          payload,
          {
            onStop: (stopFn: () => void) => {
              stopPollingFn = stopFn;
            },
          }
        ),
        cancel: take(PAYMENTS_CLAIMS_DOP_CANCEL),
      });
      if (cancel) {
        if (typeof stopPollingFn === 'function') {
          stopPollingFn();
        }
        yield put(fetchPaymentsClaimsDopLoading(false));
        if (key) {
          yield put(paymentsPollingCompleted());
        }
        return;
      }
      yield put(fetchPaymentsClaimsDopSuccess(result));
      yield put(fetchPaymentsClaimsDopLoading(false));
      if (key) {
        yield put(paymentsPollingCompleted());
        yield put(reimbursementPollingCompleted(correlationId));
      }
    }catch (error: any) {
        yield put(
          fetchPaymentsClaimsDopError(error?.message || 'An error occurred')
        );
        yield put(fetchPaymentsClaimsDopLoading(false));
        if (key) {
          yield put(paymentsPollingFailed(error)); // Decrement polling counter on error (bulk flow only)
        }
    }finally {
      if (yield cancelled()) {
        if (typeof stopPollingFn === 'function') {
          stopPollingFn();
        }
        yield put(fetchPaymentsClaimsDopLoading(false));
        if (key) {
          yield put(paymentsPollingCompleted());
          yield put(reimbursementPollingCompleted(correlationId));
        }
      }
    }
}

  export function* getClaimsBifurcateMetricsData(action: any) {
    const payload = action?.payload;
    const key = sessionStorage.getItem('HIVOLUMETINFLOW') === 'true'
      || sessionStorage.getItem('hiVolumeContractFlow') === 'true';
    const correlationId = `getClaimsBifurcateMetricsData-${Date.now()}`;
    let stopPollingFn: (() => void) | undefined;
    try {
        if (key) {
          yield put(paymentsPollingStarted());
          yield put(reimbursementPollingStarted(correlationId));
        }
        yield put(fetchClaimsBifurcateMericsLoading(true));
        const { result, cancel } = yield race({
          result: yield call(
            !key ? getClaimsBifurcateMetricsDataRequest : getClaimsBifurcateMetricsDataRequestBulk,
            payload,
            {
              onStop: (stopFn: () => void) => {
                stopPollingFn = stopFn;
              },
            }
          ),
          cancel: take(PAYMENTS_CLAIMSBIFURCATE_CANCEL),
        });
        if (cancel) {
          if (typeof stopPollingFn === 'function') {
            stopPollingFn();
          }
          yield put(fetchClaimsBifurcateMericsLoading(false));
          if (key) {
            yield put(paymentsPollingCompleted());
            yield put(reimbursementPollingCompleted(correlationId));
          }
          return;
        }
        yield put(fetchClaimsBifurcateMericsSuccess(result));
        yield put(fetchClaimsBifurcateMericsLoading(false));
        if (key) {
          yield put(paymentsPollingCompleted());
          yield put(reimbursementPollingCompleted(correlationId));
        }
      }catch (error: any) {
          yield put(
            fetchClaimsBifurcateMericsError(error?.message || 'An error occurred')
          );
          yield put(fetchClaimsBifurcateMericsLoading(false));
          if (key) {
            yield put(paymentsPollingFailed(error)); // Decrement polling counter on error (bulk flow only)
          }
      }finally {
        if (yield cancelled()) {
          if (typeof stopPollingFn === 'function') {
            stopPollingFn();
          }
          yield put(fetchClaimsBifurcateMericsLoading(false));
          if (key) {
            yield put(paymentsPollingCompleted());
            yield put(reimbursementPollingCompleted(correlationId));
          }
        }
      }
  }

export function* getPaymentsClaimsPaidData(action: any) {
  const payload = action?.payload;
  const key = sessionStorage.getItem('HIVOLUMETINFLOW') === 'true'
    || sessionStorage.getItem('hiVolumeContractFlow') === 'true';
  const correlationId = `getPaymentsClaimsPaidData-${Date.now()}`;
  let stopPollingFn: (() => void) | undefined;

  try {
      if (key) {
        yield put(paymentsPollingStarted());
        yield put(reimbursementPollingStarted(correlationId));
      }
      yield put(fetchPaymentsClaimsPaidLoading(true));
      const { result, cancel } = yield race({
        result: yield call(
          !key ? getPaymentsClaimPaidDataRequest : getPaymentsClaimPaidDataRequestBulk,
          payload,
          {
            onStop: (stopFn: () => void) => {
              stopPollingFn = stopFn;
            },
          }
        ),
        cancel: take(PAYMENTS_CLAIMSPAID_CANCEL),
      });
      if (cancel) {
        if (typeof stopPollingFn === 'function') {
          stopPollingFn();
        }
        yield put(fetchPaymentsClaimsPaidLoading(false));
        if (key) {
          yield put(paymentsPollingCompleted());
          yield put(reimbursementPollingCompleted(correlationId));
        }
        return;
      }
      yield put(fetchPaymentsClaimsPaidSuccess(result));
      yield put(fetchPaymentsClaimsPaidLoading(false));
      if (key) {
yield put(paymentsPollingCompleted());
        yield put(reimbursementPollingCompleted(correlationId));
      }
    }catch (error: any) {
        yield put(
          fetchPaymentsClaimsPaidError(error?.message || 'An error occurred')
        );
        yield put(fetchPaymentsClaimsPaidLoading(false));
        if (key) {
          yield put(paymentsPollingFailed(error)); // Decrement polling counter on error (bulk flow only)
        }
    }finally {
      if (yield cancelled()) {
        if (typeof stopPollingFn === 'function') {
          stopPollingFn();
        }
        yield put(fetchPaymentsClaimsPaidLoading(false));
        if (key) {
          yield put(paymentsPollingCompleted());
          yield put(reimbursementPollingCompleted(correlationId));
        }
      }
    }
}

export function* getPaymentsClaimsSummaryData(action: any) {
  const payload = action?.payload;
  const key = sessionStorage.getItem('HIVOLUMETINFLOW') === 'true'
    || sessionStorage.getItem('hiVolumeContractFlow') === 'true';
  const correlationId = `getPaymentsClaimsSummaryData-${Date.now()}`;
  let stopPollingFn: (() => void) | undefined;
  try {
      if (key) {
yield put(paymentsPollingStarted());
        yield put(reimbursementPollingStarted(correlationId));
      }
      yield put(fetchPaymentsClaimsSummaryLoading(true));
      const { result, cancel } = yield race({
        result: yield call(
          !key ? getPaymentsClaimsSummaryDataRequest : getPaymentsClaimsSummaryDataRequestBulk,
          payload,
          {
            onStop: (stopFn: () => void) => {
              stopPollingFn = stopFn;
            },
          }
        ),
        cancel: take(PAYMENTS_CLAIMSSUMMARY_CANCEL),
      });
      if (cancel) {
        if (typeof stopPollingFn === 'function') {
          stopPollingFn();
        }
        yield put(fetchPaymentsClaimsSummaryLoading(false));
        if (key) {
          yield put(paymentsPollingCompleted());
          yield put(reimbursementPollingCompleted(correlationId));
        }
        return;
      }
      yield put(fetchPaymentsClaimsSummarySuccess(result));
      yield put(fetchPaymentsClaimsSummaryLoading(false));
      if (key) {
        yield put(paymentsPollingCompleted());
        yield put(reimbursementPollingCompleted(correlationId));

      }
    }catch (error: any) {
        yield put(
          fetchPaymentsClaimsSummaryError(error?.message || 'An error occurred')
        );
        yield put(fetchPaymentsClaimsSummaryLoading(false));
        if (key) {
          yield put(paymentsPollingFailed(error)); // Decrement polling counter on error (bulk flow only)
        }
    }finally {
      if (yield cancelled()) {
        if (typeof stopPollingFn === 'function') {
          stopPollingFn();
        }
        yield put(fetchPaymentsClaimsSummaryLoading(false));
        if (key) {
          yield put(paymentsPollingCompleted());
          yield put(reimbursementPollingCompleted(correlationId));
        }
      }
      }
}

export function* getClaimsYieldAllPassesMetricsData(action: any) {
  const payload = action?.payload;
  const key = sessionStorage.getItem('HIVOLUMETINFLOW') === 'true'
    || sessionStorage.getItem('hiVolumeContractFlow') === 'true';
  const correlationId = `getClaimsYieldAllPassesMetricsData-${Date.now()}`;
  let stopPollingFn: (() => void) | undefined;
  try {
      if (key) {
yield put(paymentsPollingStarted());
        yield put(reimbursementPollingStarted(correlationId));
      }
      yield put(fetchClaimsYieldAllPassesMetricsLoading(true));
      const { result, cancel } = yield race({
        result: yield call(
          !key ? getClaimsYieldAllPassesMetricsDataRequest : getClaimsYieldAllPassesMetricsDataRequestBulk,
          payload,
          {
            onStop: (stopFn: () => void) => {
              stopPollingFn = stopFn;
            },
          }
        ),
        cancel: take(PAYMENTS_CLAIMSYIELD_CANCEL),
      });
      if (cancel) {
        if (typeof stopPollingFn === 'function') {
          stopPollingFn();
        }
        yield put(fetchClaimsYieldAllPassesMetricsLoading(false));
        if (key) {
          yield put(paymentsPollingCompleted());
          yield put(reimbursementPollingCompleted(correlationId));
        }
        return;
      }
      yield put(fetchClaimsYieldAllPassesMetricsSuccess(result));
      yield put(fetchClaimsYieldAllPassesMetricsLoading(false));
      if (key) {
        yield put(paymentsPollingCompleted());
        yield put(reimbursementPollingCompleted(correlationId));
      }
    }catch (error: any) {
        yield put(
          fetchClaimsYieldAllPassesMetricsError(error?.message || 'An error occurred')
        );
        yield put(fetchClaimsYieldAllPassesMetricsLoading(false));
        if (key) {
          yield put(paymentsPollingFailed(error)); // Decrement polling counter on error (bulk flow only)
        }
    }finally {
      if (yield cancelled()) {
        if (typeof stopPollingFn === 'function') {
          stopPollingFn();
        }
        yield put(fetchClaimsYieldAllPassesMetricsLoading(false));
        if (key) {
          yield put(paymentsPollingCompleted());
          yield put(reimbursementPollingCompleted(correlationId));
        }
      }
      }
}

export function* getServiceTypePassWiseMetricsData(action: any) {
  const payload = action?.payload;
  const key = sessionStorage.getItem('HIVOLUMETINFLOW') === 'true'
    || sessionStorage.getItem('hiVolumeContractFlow') === 'true';
  const correlationId = `getServiceTypePassWiseMetricsData-${Date.now()}`;
  let stopPollingFn: (() => void) | undefined;
  try {
      if (key) {
yield put(paymentsPollingStarted());
        yield put(reimbursementPollingStarted(correlationId));
      }
      yield put(fetchServiceTypePassWiseMetricsLoading(true));
      const { result, cancel } = yield race({
        result: yield call(
          !key ? getServiceTypePassWiseMetricsDataRequest : getServiceTypePassWiseMetricsDataRequestBulk,
          payload,
          {
            onStop: (stopFn: () => void) => {
              stopPollingFn = stopFn;
            },
          }
        ),
        cancel: take(PAYMENTS_CLAIMS_SERVICE_PASS_CANCEL),
      });
      if (cancel) {
        if (typeof stopPollingFn === 'function') {
          stopPollingFn();
        }
        yield put(fetchServiceTypePassWiseMetricsLoading(false));
        if (key) {
          yield put(paymentsPollingCompleted());
          yield put(reimbursementPollingCompleted(correlationId));
        }
        return;
      }
      yield put(fetchServiceTypePassWiseMetricsSuccess(result));
      yield put(fetchServiceTypePassWiseMetricsLoading(false));
      if (key) {
yield put(paymentsPollingCompleted()); // Decrement polling counter (bulk flow only)
        yield put(reimbursementPollingCompleted(correlationId));
      }
    }catch (error: any) {
        yield put(
          fetchServiceTypePassWiseMetricsError(error?.message || 'An error occurred')
        );
        yield put(fetchServiceTypePassWiseMetricsLoading(false));
        if (key) {
          yield put(paymentsPollingFailed(error)); // Decrement polling counter on error (bulk flow only)
        }
    }finally {
      if (yield cancelled()) {
        if (typeof stopPollingFn === 'function') {
          stopPollingFn();
        }
        yield put(fetchServiceTypePassWiseMetricsLoading(false));
        if (key) {
          yield put(paymentsPollingCompleted());
          yield put(reimbursementPollingCompleted(correlationId));
        }
      }
    }
}

export function* paymentsSaga() {
  yield takeLatest(
    PAYMENTS_CLAIMS_PAID_REQUEST,
    getPaymentsClaimsPaidData
  );
  yield takeLatest(
    CLAIMS_YIELD_ALL_PASSES_METRICS_REQUEST,
    getClaimsYieldAllPassesMetricsData
  );
  yield takeLatest(
    SERVICE_TYPE_PASS_WISE_METRICS_REQUEST,
    getServiceTypePassWiseMetricsData
  );
  yield takeLatest(
    PAYMENTS_CLAIMS_SUMMARY_REQUEST,
    getPaymentsClaimsSummaryData
  );
  yield takeLatest(
    PAYMENTS_CLAIMS_DOP_REQUEST,
    getDOPClaimsSummaryData
  );
  yield takeLatest(
    CLAIMS_BIFURCATE_METRICS_REQUEST,
    getClaimsBifurcateMetricsData
  );
}